import { render, staticRenderFns } from "./ChangeLogObjectButtonAction.vue?vue&type=template&id=b26669f0"
import script from "./ChangeLogObjectButtonAction.vue?vue&type=script&lang=js"
export * from "./ChangeLogObjectButtonAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports